import type { LandingPageContent } from './types'

export const HANDWERKER_PHOTOVOLTAIK_AUFTRAEGE: LandingPageContent = {
  slug: 'handwerker-photovoltaik-auftraege',
  lang: 'de',
  topicId: 'handwerker-photovoltaik-auftraege',
  title: 'Photovoltaik-Aufträge finden – kostenlos, ohne Abo | Für Handwerksbetriebe',
  metaDescription:
    'Kostenlos Photovoltaik-Anfragen sehen und Angebote abgeben, ohne Abo oder Mindestabnahme - ' +
    'Kontakt zum Kunden erst nach dessen aktiver Freigabe.',
  keywords: [
    'photovoltaik aufträge finden',
    'photovoltaik leads kaufen',
    'kostenlose photovoltaik leads',
    'handwerker portal photovoltaik ohne abo',
    'pv anfragen handwerksbetrieb',
  ],
  eyebrow: 'Für Handwerksbetriebe',
  h1: 'Photovoltaik-Aufträge finden – kostenlos, ohne Abo',
  intro:
    'Roofora ist für Handwerksbetriebe komplett kostenlos nutzbar: Anfragen ansehen, Angebote ' +
    'abgeben, mit Kunden in Kontakt kommen - ohne Abo, ohne Mindestabnahme, ohne Vorabkosten. Sie ' +
    'sehen anonymisierte Photovoltaik-Anfragen aus Ihrer Region und entscheiden selbst, für welche ' +
    'Sie ein Angebot abgeben.',
  sections: [
    { type: 'heading', text: 'Wie sich das von klassischen Lead-Portalen unterscheidet' },
    {
      type: 'paragraph',
      text:
        'Viele Portale verkaufen Handwerksbetrieben Kontaktdaten von Interessenten - oft für einen ' +
        'festen Preis pro Lead, teils mit Abo oder Mindestabnahme, unabhängig davon, ob daraus ein ' +
        'Auftrag entsteht. Bei Roofora sehen Sie stattdessen anonymisierte Anfragen, geben unverbindlich ' +
        'ein Festpreis-Angebot ab, und bekommen die Kontaktdaten erst, wenn der Kunde genau Ihren ' +
        'Betrieb individuell freigibt - keine pauschale Weitergabe an mehrere Betriebe gleichzeitig.',
    },
    { type: 'heading', text: 'So funktioniert es für Ihren Betrieb' },
    {
      type: 'list',
      items: [
        'Kostenlos registrieren, keine Abo-Bindung',
        'Anonymisierte Anfragen in Ihrer Region durchsehen (PLZ-Gebiet, Dachdaten, Verbrauch)',
        'Unverbindlich ein Festpreis-Angebot abgeben, jederzeit anpassbar',
        'Kontaktdaten des Kunden erst nach dessen individueller Freigabe für genau Ihren Betrieb',
      ],
    },
    { type: 'heading', text: 'Keine Kaltakquise-Erwartung an Sie' },
    {
      type: 'paragraph',
      text:
        'Sie müssen niemanden anrufen, um an eine Anfrage zu kommen - alle Anfragen sind bereits da, ' +
        'anonymisiert und bereit für Ihr Angebot. Der Aufwand für Bedarfsanalyse und Erstkontakt, den ' +
        'Sie anderswo oft in den Angebotspreis einkalkulieren müssen, entfällt hier weitgehend.',
    },
  ],
  faq: [
    {
      q: 'Kostet die Registrierung oder Angebotsabgabe etwas?',
      a: 'Nein - die Nutzung von Roofora ist für Handwerksbetriebe aktuell komplett kostenlos, ohne Abo und ohne Mindestabnahme.',
    },
    {
      q: 'Bekomme ich die Kontaktdaten des Kunden automatisch, wenn ich ein Angebot abgebe?',
      a: 'Nein - Kontakt entsteht erst, wenn der Kunde Ihren Betrieb individuell freigibt. Andere Betriebe können unabhängig davon ebenfalls Angebote abgeben, ohne dass automatisch alle Kontaktdaten erhalten.',
    },
    {
      q: 'Wie viele andere Betriebe sehen dieselbe Anfrage?',
      a: 'Sie sehen die Anzahl bereits abgegebener Angebote, aber nicht deren Preise - Sie können Ihr eigenes Angebot jederzeit anpassen.',
    },
    {
      q: 'Für welche Auftragsarten kann ich mich registrieren?',
      a: 'Komplettsysteme mit Montage, reine Dachmontage, Elektroinstallation und Wärmepumpe - je nachdem, welche Leistungen Ihr Betrieb anbietet.',
    },
  ],
  primaryCta: { label: 'Kostenlos als Handwerksbetrieb registrieren', action: 'craftsman' },
  secondaryCta: { label: 'Wie funktioniert der Angebotsvergleich für Kunden?', action: 'link', href: '/pv-angebot-vergleichen' },
  relatedLinks: [
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
    { label: 'PV-Installateur finden', href: '/pv-installateur-finden' },
  ],
}
